<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "AdminMessagesWrapper"
    }
</script>

<style scoped>

</style>